import {useFrame} from "@react-three/fiber";
import {CameraControls} from "@react-three/drei";
import React, {useRef, useState} from "react";
import { Vector3 } from 'three';

interface CameraDriftProps {
  target: number[];
  driftCenter: number[];
  driftScale: number;
  driftSpeed: number;
}


function CameraDrift(props: CameraDriftProps) {
  const controls = useRef<CameraControls>(null!);
  const [enabled, setEnabled] = useState(true);
  const timeout = useRef<number | undefined>(undefined);
  useFrame(({ camera, clock}) => {
    if (!enabled) return;
    const position = new Vector3(props.driftCenter[0], props.driftCenter[1], props.driftCenter[2]);
    const driftOffset = new Vector3(
      4 * Math.cos(clock.elapsedTime * props.driftSpeed),
      Math.sin(clock.elapsedTime * 2 * props.driftSpeed),
      0);
    driftOffset.multiplyScalar(props.driftScale);
    position.add(driftOffset);

    void controls.current.setLookAt(
      position.x, position.y, position.z,
      props.target[0], props.target[1], props.target[2],
      true);
  });

  return (
    <CameraControls
      ref={controls}
      onStart={() => { setEnabled(false) }}
      onEnd={() => {
        if (timeout.current) {
          window.clearTimeout(timeout.current);
        }
        timeout.current = window.setTimeout(() => setEnabled(true), 15 * 1000)
      }}
      makeDefault
    />
  )
}

export default CameraDrift;
